import React, { useState } from 'react';
import SEO from '../components/SEO';

function Contact({ language, t }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    kvkk: false
  });

  const isArabic = language === 'ar';

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.PUBLIC_URL}/contact.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          subject: formData.subject,
          message: formData.message,
          kvkkConsent: formData.kvkk,
        })
      });

      if (response.ok) {
        alert(t.messageReceived);
        setFormData({ name: '', email: '', phone: '', subject: '', message: '', kvkk: false });
      } else {
        alert('Error sending message. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error sending message. Please try again.');
    }
  };

  const handleMapClick = () => {
    window.open('https://maps.app.goo.gl/KWFFcFuGxgLuR1AA8', '_blank');
  };

  return (
    <main className="contact" dir={isArabic ? 'rtl' : 'ltr'}>
      <SEO
        title="İletişim - TAMA & ORAL Hukuk Bürosu İzmir"
        description="TAMA & ORAL Hukuk Bürosu İzmir iletişim bilgileri. Telefon: 0537 937 10 64, 0232 486 63 01. Adres: Bayraklı İzmir. Bize ulaşın, sorularınıza yanıt verelim."
        keywords="avukat iletişim izmir, hukuk bürosu telefon, bayraklı izmir, icra avukat, hukuki danışman"
        canonical="https://tamaoral.av.tr/contact"
      />
      <section className="page-header">
        <h1>{t.getInTouch}</h1>
        <p>{t.reachOut}</p>
      </section>

      <section className="contact-content">
        <div className="contact-info">
          <div className="info-item info-item-clickable" onClick={handleMapClick}>
            <h3>📍 {t.address}</h3>
            <p>{t.addressText}</p>
            <span className="map-link">→ Open in Google Maps</span>
          </div>
          <div className="info-item">
            <h3>📞 {t.phone}</h3>
            <p>
              <strong>{t.mobile}</strong><br/>
              {t.mobilePhone}<br/>
              <br/>
              <strong>{t.landline}</strong><br/>
              {t.landlinePhone}
            </p>
          </div>
          <div className="info-item">
            <h3>✉️ {t.email}</h3>
            <p>
              <a href="mailto:info@tamaoral.av.tr">info@tamaoral.av.tr</a><br/>
              <a href="mailto:arabuluculuk@tamaoral.av.tr">arabuluculuk@tamaoral.av.tr</a>
            </p>
          </div>
          <div className="info-item">
            <h3>⏰ {t.workingHours}</h3>
            <p>{t.workingHoursText}</p>
          </div>
        </div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <h2>{t.sendMessage}</h2>

          <div className="form-group">
            <label htmlFor="name">{t.fullNameReq}</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">{t.emailReq}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">{t.phone2}</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">{t.subject}</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">{t.message}</label>
            <textarea
              id="message"
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <div className="form-group form-checkbox">
            <label htmlFor="kvkk">
              <input
                type="checkbox"
                id="kvkk"
                name="kvkk"
                checked={formData.kvkk}
                onChange={handleChange}
                required
              />
              <span>{t.kvkkText}</span>
            </label>
          </div>

          <button type="submit" className="submit-btn">{t.send}</button>
        </form>
      </section>

      <section className="map-section">
        <h2>{t.ourLocation}</h2>
        <iframe
          title="TAMA & ORAL Hukuk Bürosu konum haritası"
          width="100%"
          height="400"
          frameBorder="0"
          style={{ border: 0 }}
          src="https://www.google.com/maps?q=38.4515211,27.1868503&z=17&output=embed"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </main>
  );
}

export default Contact;
